import { createSlice } from '@reduxjs/toolkit'
import Cookies from 'js-cookie';

const initialState = {
  loggedIn: false,
  isCheckingAuth: true, // CRUCIAL: App starts in a "checking" state
  forgetPassword: false,
  resetPassword: false,
  confirmNewPassword: false,
  user: undefined
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    userLogin: (state, action) => {
      state.loggedIn = true;
      state.isCheckingAuth = false; // Stop loading on success
      state.user = action.payload.user;
      if (action.payload.user["token"] !== undefined) {
        Cookies.set('bambkuss-token', action.payload.user["token"], { expires: 7, secure: false });
      }
    },

    stopAuthLoading: (state) => {
      state.isCheckingAuth = false; // Stop loading on failure or no token
    },

    userLogout: (state) => {
      state.loggedIn = false;
      state.isCheckingAuth = false; // Ensure this is false on logout
      state.forgetPassword = false;
      state.resetPassword = false;
      state.user = {};
      Cookies.remove('bambkuss-token');
    },

    userRegistered: (state, action) => {
      if (action.payload.success) {
        state.registered = true;
        console.log("registered")
      } else {
        state.registered = false;
        console.log("not registered")
      }
    },

    userForgetPassword: (state) => {
      state.forgetPassword = true;
    },

    userResetPassword: (state, action) => {
      state.resetPassword = true;
      state.user = action.payload.user;
      console.log("userResetPassword")
    },

    userConfirmNewPassword: (state) => {
      state.confirmNewPassword = true;
    }
  },
})

export const { 
  userLogin, 
  stopAuthLoading, 
  userLogout, 
  userRegistered, 
  userForgetPassword, 
  userResetPassword,
  userConfirmNewPassword
} = userSlice.actions

export default userSlice.reducer